import { render } from "./ShowHide.vue?vue&type=template&id=23ce901c&ts=true"
import script from "./ShowHide.vue?vue&type=script&lang=ts"
export * from "./ShowHide.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__